var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text && _vm.logo && _vm.link)?_c('div',{staticStyle:{"margin-left":"46px"}},[_c('h4',[_vm._v(_vm._s(_vm.text))]),_c('a',{attrs:{"href":_vm.link}},[_c('v-img',{attrs:{"max-height":"30","max-width":"148","src":_vm.logo}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }